module.exports = __webpack_public_path__ + "img/partners2.c05c5cdd.png";